import Rebase from 're-base';
import firebase from 'firebase/app';
import 'firebase/database';

var app = firebase.initializeApp({
    apiKey: "AIzaSyBtXkMDz2IZfl2EIe_k4LvoG5i-AW8RQlo",
    authDomain: "biek-edu.firebaseapp.com",
    databaseURL: "https://biek-edu.firebaseio.com",
    projectId: "biek-edu",
    storageBucket: "biek-edu.appspot.com",
    messagingSenderId: "850602785565"
});

var db = firebase.database(app);
var base = Rebase.createClass(db);

export default base;